import { useState } from "react";
import OverviewSection from "../../component/wallet/OverviewSection";
import TransactionSection from "../../component/wallet/TransactionSection";
import BeneficiariesSection from "../../component/wallet/BeneficiariesSection";
import NewDashboardLayout from "../../component/layout/NewDashboardLayout";
import CustomHeader from "../../component/CustomHeader";

const Wallets = () => {
    const [view, setView] = useState("Transactions");
    const [beneficiariesCount, setBeneficiariesCount] = useState(0);
    const shortCount = (n) => (n > 999 ? `${Math.floor(n / 1000)}k+` : n);

    return (
        <NewDashboardLayout>
            <div className="w-full min-h-screen bg-bg-color-10">
                <CustomHeader title="Wallets" />
                {/* Overview */}
                <OverviewSection />
                {/* Tabs */}
                <div className="flex gap-8 mt-10 ml-6 border-b border-gray-200">
                    {["Transactions", "Beneficiaries"].map((tab) => (
                        <button
                            key={tab}
                            onClick={() => setView(tab)}
                            className={`relative pb-2 text-sm font-medium ${
                                view === tab ? "text-[#161827]" : "text-[#667085]"
                            }`}
                        >
                            {tab}
                            {tab === "Beneficiaries" && beneficiariesCount > 0 && (
                                <span className="ml-2 px-2 py-0.5 rounded-full bg-[#6F739B] text-white text-xs">
                                    {shortCount(beneficiariesCount)}
                                </span>
                            )}
                            {view === tab && (
                                <span className="absolute -bottom-[1px] left-0 right-0 h-[2px] bg-[#6F00FF] rounded-full" />
                            )}
                        </button>
                    ))}
                </div>
                {/* Conditional Render */}
                {view === "Transactions" ? (
                    <TransactionSection />
                ) : (
                    <BeneficiariesSection onCountChange={setBeneficiariesCount} />
                )}
            </div>
        </NewDashboardLayout>
    );
};

export default Wallets;
